import { render, staticRenderFns } from "./FGscan.vue?vue&type=template&id=64d568c4&"
import script from "./FGscan.vue?vue&type=script&lang=js&"
export * from "./FGscan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports